module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pb-3",
    attrs: {
      "flat": ""
    }
  }, [_c('h3', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("ĐÁNH GIÁ CÁN BỘ")]), _vm._v(" "), (_vm.agencyName) ? _c('h3', {
    staticClass: "text-xs-center pb-2",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.agencyName))]) : _vm._e(), _vm._v(" "), (_vm.employeeItems.length > 0) ? _c('div', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.employeeItems), function(employee) {
    return _c('v-flex', {
      key: employee.employeeId,
      staticClass: "px-2 py-2",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg3": ""
      }
    }, [_c('v-card', {
      staticStyle: {
        "box-shadow": "none"
      },
      attrs: {
        "flat": "",
        "hover": "",
        "color": "#1a571b21"
      }
    }, [_c('v-card-text', {
      staticClass: "py-2 px-1",
      staticStyle: {
        "overflow": "hidden"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.viewDetailEmployee(employee)
        }
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "xs4": ""
      }
    }, [(employee['imgSrc']) ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "max-width": "100px",
        "height": "150px",
        "margin": "0 auto",
        "background-position": "center",
        "background-size": "cover"
      },
      style: ('background-image: url(' + employee['imgSrc'] + ');')
    }) : _c('img', {
      staticStyle: {
        "max-width": "100%",
        "height": "150px",
        "object-fit": "contain",
        "background": "#ddd",
        "opacity": "0.6"
      },
      attrs: {
        "src": "/o/opencps-store/js/kios_bng/img/avatar_contacts.png"
      }
    })]), _vm._v(" "), _c('v-flex', {
      staticStyle: {
        "word-wrap": "break-word"
      },
      attrs: {
        "xs8": ""
      }
    }, [_c('div', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(employee.jobPosTitle))]), _vm._v(" "), _c('div', {
      staticClass: "text-bold primary--text mb-2"
    }, [_vm._v(_vm._s(employee.fullName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(employee.workingUnitName))]), _vm._v(" "), _c('div', [_vm._v("Email: " + _vm._s(employee.email))])])], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "my-0",
      attrs: {
        "light": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "py-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.viewDetailEmployee(employee)
        }
      }
    }, [_c('v-layout', {
      staticClass: "px-3",
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "pt-2",
      staticStyle: {
        "max-width": "100px"
      }
    }, [_c('span', {
      staticClass: "text-bold"
    }, [_vm._v("Đánh giá:")])]), _vm._v(" "), _c('v-flex', [_c('star-rating', {
      attrs: {
        "read-only": "",
        "rating": employee['score'] ? employee['score'] : 0,
        "increment": 0.1,
        "max-rating": 5,
        "show-rating": false,
        "star-size": 30
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      staticClass: "px-3",
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticStyle: {
        "max-width": "100px"
      }
    }, [_c('span', {
      staticClass: "text-bold"
    }, [_vm._v("Kết quả:")])]), _vm._v(" "), _c('v-flex', [_c('span', {
      staticClass: "text-bold primary--text"
    }, [_vm._v(_vm._s(employee['totalVoting'] ? employee['totalVoting'] : 0) + " lượt đánh giá")])])], 1)], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), (_vm.totalEmployee > _vm.numberPerPage) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-3",
    staticStyle: {
      "width": "100%",
      "max-width": "350px",
      "margin": "0 auto"
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.lengthPage,
      "circle": ""
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.employeePage),
      callback: function($$v) {
        _vm.employeePage = $$v
      },
      expression: "employeePage"
    }
  })], 1) : _vm._e()], 1) : _c('div', [_c('v-alert', {
    staticClass: "mt-4 mx-3",
    attrs: {
      "value": true,
      "outline": "",
      "color": "blue",
      "icon": "priority_high"
    }
  }, [_vm._v("\n            Không có danh sách cán bộ\n          ")])], 1)])], 1)], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1cc2d6b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cc2d6b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DanhSachCanBo.vue
// module id = 522
// module chunks = 1